@import "../../../../globalStyles/commons";

:host {
  display: block;
  height: 100%;
  min-height: 20em;
  --calendar-border-color: var(--border-strong-01);
  --scale-color: var(--text-placeholder);

  --calendar-event-bg-color: #{v(--color-purple-20)};
  --calendar-event-bg-color--hover: #{v(--color-purple-40)};
  --calendar-event-border-color: #{v(--color-new-purple)};

  --calendar-event-dark-bg-color: #{v(--color-purple-90)};
  --calendar-event-dark-bg-color--hover: #{v(--color-purple-70)};
  --calendar-event-dark-border-color: #{v(--color-purple-70)};
}

.calendar {
  height: 100%;
  display: flex;
  flex-direction: column;

  .calendar-header {
    .calendar-header-classic {
      display: flex;
      padding: 1rem;

      .header-left {
        display: flex;
        gap: 1rem;
        align-items: center;
        flex: 1;

        .title {
          display: flex;
          align-items: center;
        }
      }
    }

    goat-select {
      margin-bottom: 0;
    }
  }

  .calendar-body {
    flex: 1;
    overflow: auto;

    .view-container {
      height: 100%;
    }
  }
}
